import { createSelector } from 'reselect';
import * as constants from './constants';
import { get, isEmpty } from '~/utils/object';

export const selectRegistration = (state: any) =>
  state[constants.STATE_ROOT_KEY];

export const getStatus = createSelector([selectRegistration], reg =>
  get(reg, 'status', constants.STATUS.PROMPT),
);

const statusIsComplete = (status: string) =>
  status === constants.STATUS.COMPLETE;

export const getError = createSelector(
  [selectRegistration, getStatus],
  (reg, status): string | null => {
    const error = isEmpty(reg?.error)
      ? constants.ERROR_NOT_PRESENT
      : get(reg, 'error', constants.ERROR_NOT_PRESENT);
    return statusIsComplete(status) ? constants.ERROR_NOT_PRESENT : error;
  },
);
